import script from "./job_details.vue?vue&type=script&setup=true&lang=js"
export * from "./job_details.vue?vue&type=script&setup=true&lang=js"

import "./job_details.vue?vue&type=style&index=0&id=773e623e&lang=css"

const __exports__ = script;

export default __exports__